var fullscreenTemplate = require('@/modules/components/fullscreen.handlebars')
import CloseIcon from '@/assets/media/icons/close.svg'
import GlobalSettings from '@/core/global-settings'
import { PLAYLIST_TYPE } from '~/configs/constants'
import { $selectedProductDetail } from '~/store/cart'
import EventManager from '@/core/event-manager'
import { MANUAL_CART_EVENTS } from '@/configs/settings'

class LoraFullscreen extends HTMLElement {
    constructor() {
        super()
        this.attachShadow({ mode: 'open' })
        this.closeIcon = CloseIcon
        this.yourBodyOverfollowStyle = 'auto'
        this.yourDocumentOverfollowStyle = 'auto'
        this.documentOverflowStyle = GlobalSettings.overflowStyle.documentOverflow
        this.bodyOverflowStyle = GlobalSettings.overflowStyle.bodyOverflow
        this.eventManager = new EventManager()
    }

    getDataAttributes() {
        $selectedProductDetail.set(this.getAttribute('product-detail-id'))
        this.playlistId = this.getAttribute('playlist-id')
        this.currentIndex = this.getAttribute('current-index') ? parseInt(this.getAttribute('current-index')) : 0
        this.videoId = this.getAttribute('video-id')
        this.loop = this.hasAttribute('loop') && this.getAttribute('loop') !== 'false' ? true : false
        this.playlistType = this.getAttribute('playlist-type')
        this.maxVideos = this.playlistType == PLAYLIST_TYPE.GRID ? this.getAttribute('max-videos') : null
        this.pipStyle = this.getAttribute('pip-style') || 'bottom: 0px; right: 15px;'
        this.uuid = this.getAttribute('uuid')
        this.customTagName = this.getAttribute('tag-name') || this.shadowRoot.host.tagName
    }

    connectedCallback() {
        this.getDataAttributes()
        this.render()
    }

    registerEvents() {
        this.yourBodyOverfollowStyle = document.body.style.overflow
        this.yourDocumentOverfollowStyle = document.documentElement.style.overflow
    }

    render() {
        document.body.style.overflow = 'hidden'
        document.documentElement.style.overflow = 'hidden'
        const context = {
            playlistId: this.playlistId,
            currentIndex: this.currentIndex,
            loop: this.loop,
            videoId: this.videoId,
            exitIcon: this.closeIcon,
            playlistType: this.playlistType,
            maxVideos: this.maxVideos,
            pipStyle: this.pipStyle,
            uuid: this.uuid,
            tagName: this.customTagName,
        }
        this.shadowRoot.innerHTML = `${fullscreenTemplate(context)}`
        //Append outside style
        const templateStyle = document.querySelector('template#lora-fullscreen')
        if (templateStyle) this.shadowRoot.appendChild(templateStyle.content.cloneNode(true))
        this.registerEvents()
        window.dispatchEvent(
            new CustomEvent('OPEN_FULLSCREEN', {
                detail: {
                    videoId: this.videoId,
                    playlistId: this.playlistId,
                    uuid: this.uuid,
                },
                composed: true,
                bubbles: true,
            })
        )
        this.handleInternalEvents()
    }

    handleInternalEvents() {
        let videoEmbed = this
        if (!this.playlistId) {
            videoEmbed = this.shadowRoot.querySelector(`video-embed[video-id="${this.videoId}"]`)
        } else {
            videoEmbed = this.shadowRoot.querySelector(`story-block-playlist`)
        }
        videoEmbed.eventManager.on(MANUAL_CART_EVENTS.SYNC_PRODUCT, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.SYNC_PRODUCT, data, callback)
        })
        videoEmbed.eventManager.on(MANUAL_CART_EVENTS.ADD_TO_CART, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.ADD_TO_CART, data, callback)
        })
        videoEmbed.eventManager.on(MANUAL_CART_EVENTS.UPDATE_ITEM_IN_CART, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.UPDATE_ITEM_IN_CART, data, callback)
        })
        videoEmbed.eventManager.on(MANUAL_CART_EVENTS.SYNC_CART_STATE, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.SYNC_CART_STATE, data, callback)
        })
        videoEmbed.eventManager.on(MANUAL_CART_EVENTS.CHECKOUT, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.CHECKOUT, data, callback)
        })
        videoEmbed.eventManager.on('UPDATE_CURRENT_INDEX', (data, callback) => {
            this.eventManager.emit('UPDATE_CURRENT_INDEX', data, callback)
        })
    }

    disconnectedCallback() {
        document.body.style.overflow = this.bodyOverflowStyle
        document.documentElement.style.overflow = this.documentOverflowStyle
    }
}
window.customElements.define('b-fullscreen', LoraFullscreen)
